import { differenceInMilliseconds, endOfDay } from 'date-fns';

export const getTimeTillEndOfDayMs = () => {
  const currentDate = new Date();
  const endOfCurrentDay = endOfDay(currentDate);

  return differenceInMilliseconds(endOfCurrentDay, currentDate);
};
